import { useContext, createContext } from 'react';
export const RadioCardContext = createContext(null);
export const useRadioCard = () => {
    const context = useContext(RadioCardContext);
    if (!context) {
        throw new Error('useRadioCard cant be rendered outside the RadioCard component');
    }
    return context;
};
//# sourceMappingURL=hook.js.map